var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3701",
    "data-name": "Rectangle 3701",
    width: 31,
    height: 31,
    transform: "translate(-0.396 -0.396)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9175",
    "data-name": "Group 9175",
    transform: "translate(-359 -698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_336",
    "data-name": "Ellipse 336",
    transform: "translate(359 698)",
    fill: "#151926",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9159",
    "data-name": "Group 9159",
    transform: "translate(374.396 713.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9158",
    "data-name": "Group 9158",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44033",
    "data-name": "Path 44033",
    d: "M2.149,20.572c1.007-1.214,1.96-2.36,2.91-3.508a3.87,3.87,0,0,1,6-.054c.442.516.867,1.046,1.318,1.591.559-.637,1.107-1.261,1.655-1.887.758-.866,1.514-1.735,2.275-2.6a3.968,3.968,0,0,1,6-.01q2.717,3.085,5.415,6.188c.093.107.188.212.35.4V20.27q0-3.882,0-7.764a1.889,1.889,0,0,1,.053-.486,1.076,1.076,0,0,1,1.082-.785,1.06,1.06,0,0,1,.96,1.037c.012.745.006,1.491.005,2.237,0,3.092.023,6.185-.014,9.277a6.591,6.591,0,0,1-5.181,6.241,8.3,8.3,0,0,1-1.663.165Q15.1,30.21,6.873,30.2A6.648,6.648,0,0,1,.142,24.829a6.748,6.748,0,0,1-.13-1.371C0,17.921.025,12.383,0,6.846A6.655,6.655,0,0,1,4.612.352,7.87,7.87,0,0,1,6.806.021c3.64-.033,7.281-.016,10.922-.014a1.109,1.109,0,0,1,1.181.7,1.066,1.066,0,0,1-.976,1.419c-.175.011-.351,0-.526,0q-5.329,0-10.659,0a4.523,4.523,0,0,0-4.5,3.549,4.031,4.031,0,0,0-.107.91q-.011,6.842-.005,13.685c0,.073.008.145.018.3m12.886,7.5c2.828,0,5.657.009,8.485,0a4.489,4.489,0,0,0,4.426-4.006.633.633,0,0,0-.136-.43c-.7-.817-1.411-1.62-2.12-2.427q-2.5-2.841-4.993-5.68a1.824,1.824,0,0,0-2.907.031l-.476.545q-2.065,2.366-4.13,4.732a1.081,1.081,0,0,1-1.792-.038c-.636-.769-1.275-1.534-1.91-2.3a1.806,1.806,0,0,0-2.916.01c-1.37,1.669-2.733,3.344-4.121,5a.987.987,0,0,0-.215.952,4.549,4.549,0,0,0,4.516,3.619q4.144.008,8.288,0",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44034",
    "data-name": "Path 44034",
    d: "M229.942,6.47c0,.155,0,.284,0,.412,0,.921.01,1.843-.01,2.763a1.044,1.044,0,0,1-1.932.527,1.539,1.539,0,0,1-.173-.685c-.018-.986-.008-1.973-.008-3.017h-.355c-.921,0-1.842.006-2.764,0a1.077,1.077,0,0,1-1.03-.729.978.978,0,0,1,.371-1.162,1.6,1.6,0,0,1,.767-.219c.877-.026,1.754-.01,2.632-.01h.379c0-1.051,0-2.058,0-3.066a1.068,1.068,0,0,1,.862-1.12,1.041,1.041,0,0,1,1.255,1.078c.016.9,0,1.8.005,2.7,0,.119,0,.238,0,.39.143.007.259.018.376.018.921,0,1.842-.008,2.764.006a1.049,1.049,0,0,1,1.033.764,1.016,1.016,0,0,1-.429,1.15,1.55,1.55,0,0,1-.711.2c-.877.023-1.754.009-2.632.009h-.4",
    transform: "translate(-203.954 -0.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44035",
    "data-name": "Path 44035",
    d: "M51.9,47.986A3.862,3.862,0,1,1,48.025,51.8,3.855,3.855,0,0,1,51.9,47.986m-1.752,3.858A1.743,1.743,0,0,0,51.891,53.6a1.778,1.778,0,0,0,1.751-1.762A1.75,1.75,0,0,0,51.9,50.108a1.724,1.724,0,0,0-1.755,1.735",
    transform: "translate(-43.803 -43.767)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEdit);
export default __webpack_public_path__ + "static/media/logo-edit.7ecf8c8e08360e9ed8bd59e73217a9ff.svg";
export { ForwardRef as ReactComponent };